var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#f1f3f5;}.b{stroke:#304669;}.c{fill:#304669;}.d{stroke:none;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39 -574)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(39 574)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-388 501)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(435 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 24,
    height: 27,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 26,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(437 86)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 20,
    height: 19,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 18,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(443 82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(446 82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(449 82)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/Device.2c99ed95e45731804f4dd1f31baec83d.svg";
export { ForwardRef as ReactComponent };